import React from "react"
import Page from "./Page"

function Admin() {
    return <Page title="Admin"></Page>
}

export default Admin
